import { TOOLS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/tools_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['toolsIndex', 'toolsAdvancedFilters']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
